import {useTranslation} from "@i18n/client";
import React from "react";

const FraudAlert = () => {
  const {t} = useTranslation();
  return (
    <section className="p-8 lg:p-16" id="fraud_alert">
      <div className="flex flex-col max-w-[80rem] m-auto bg-error-100 rounded-2xl p-8 lg:p-16 gap-8 lg:gap-14">
        <div className="flex flex-col items-start gap-4">
          <div className="bg-error-800 body-sm-bold text-white p-[10px] flex items-center gap-2 rounded-full">
            <span className="cIcon-warning" />
            <span>{t("Warning")}</span>
          </div>
          <h2 className="heading-4xl">Job Scam Alert</h2>
        </div>
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="flex flex-col gap-8">
            <p className="body-lg">
              Scammers are sending job scam emails pretending to be recruiters at Carbon Health.
              These emails are designed to trick candidates into providing personal information and
              potentially engage in criminal activity. If someone from Carbon Health reaches out to
              you on social media, we’ll use the platform to make contact and will move the
              conversation to phone/email.
            </p>
            <p className="body-lg">
              All Carbon Health emails will come from the @carbonhealth.com domain—it will never
              have any other domain attached to the email address.
            </p>
          </div>
          <div className="flex flex-col gap-8">
            <p className="body-lg">
              <strong>We will never</strong> request payment as a condition for applying for a
              position or receiving an offer of employment. <strong>We will never</strong> interview
              over Zoom, Messenger, Telegram, Teams or Skype. Any social media or email messages
              about a job will instruct you to{" "}
              <a href="#careers" className="text-gray-1000 hover:text-gray-800 underline">
                apply directly on our careers site
              </a>{" "}
              with an official job application.
            </p>
            <p className="body-lg">
              If you have been a target of a job scam, report it by contacting the{" "}
              <a
                href="https://consumer.ftc.gov/articles/job-scams"
                className="text-gray-1000 hover:text-gray-800 underline"
              >
                U.S. Federal Trade Commission
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(FraudAlert);
